<template>
  <is-loading v-if="isSupportedOauthClient" :if="isLoading" :centered="true">
    <ValidationObserver ref="observer" slim>
      <shop-provider
        :route-client-id="routeClientId"
        :route-account-id="routeAccountId"
      >
        <template v-slot:default="{ $shopData, $shopMethods }">
          <basket-provider
            :key="$shopData.shopBasketKey"
            :route-client-id="routeClientId"
            :route-account-id="routeAccountId"
            :route-basket-id="routeBasketId"
            :route-order-id="routeOrderId"
            :billing-term="billingTerm"
            :quantity="quantity"
            :route-currency-code="routeCurrencyCode"
            :route-coupons="routeCoupons"
            :route-cross-sell="routeCrossSell"
            :route-read-more="routeReadMore"
            :loader-attrs="{ isAbsolute: true }"
            @newClientSelected="$shopMethods.assignToNewBasketShop"
            @basketChanged="$shopMethods.setBasketId"
            @basketNotFound="$shopMethods.backToBasketList"
            @basketResetted="$shopMethods.resetBasket"
            @basketNoLongerExists="$shopMethods.goToShop"
            @basketSetForClient="$shopMethods.goToCheckout"
            @productQuicklyAdded="$shopMethods.goToBasket"
            @viewCategory="$shopMethods.goToShop"
            @viewProduct="$shopMethods.goToProductView"
          >
            <basket-provisioning-provider>
              <router-view />
            </basket-provisioning-provider>
          </basket-provider>
        </template>
      </shop-provider>
    </ValidationObserver>
  </is-loading>
  <div v-else class="has-padding-100">
    <div :style="{ flexGrow: 0, maxWidth: '24rem', margin: 'auto' }">
      <b-message type="is-dark">
        <i18n path="_sentence.action_unsupported_by_oauth_client">
          <template #action>
            <i18n path="_.our_online_store" />
          </template>
          <template #origin>
            <strong>{{ currentOauthClient }}</strong>
          </template>
          <template #click>
            <a :href="defaultOauthClientRedirect">{{
              $t("_action.click_here").toLowerCase()
            }}</a>
          </template>
        </i18n>
      </b-message>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import type { PropType } from "vue";

export default defineComponent({
  name: "OrderView",
  components: {
    "basket-provider": () =>
      import("@/components/app/global/baskets/basket/basketProvider.vue"),
    "basket-provisioning-provider": () =>
      import("@/components/app/global/baskets/basket/provisioningProvider.vue"),
    "shop-provider": () =>
      import("@/components/app/global/baskets/basket/shopProvider.vue")
  },
  props: {
    routeClientId: { type: String as PropType<string | number>, default: "" },
    routeAccountId: { type: String as PropType<string | number>, default: "" },
    routeBasketId: { type: String as PropType<string | number>, default: "" },
    routeOrderId: { type: String as PropType<string | number>, default: "" },
    billingTerm: { type: Number, default: 0 },
    quantity: { type: Number, default: 1 },
    routeCurrencyCode: { type: String, default: "" },
    routeCoupons: { type: String, default: "" },
    routeCrossSell: { type: Boolean, default: false },
    routeReadMore: { type: Boolean, default: false }
  },
  data: () => ({
    isLoading: true
  }),
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect",
      isClientAuthenticated: "auth/client/isAuthenticated",
      isGuestAuthenticated: "auth/guest/isAuthenticated"
    })
  },
  async created() {
    if (this.isSupportedOauthClient) {
      if (this.isClientAuthenticated || this.isGuestAuthenticated) {
        this.isLoading = false;
        return;
      }

      await this.$store.dispatch("auth/guest/createToken");
      this.isLoading = false;
    }
  }
});
</script>
